// extracted by mini-css-extract-plugin
module.exports = {"content":"MarkdownContent_content__5aPIO"};